import classnames from 'classnames';
import React from 'react';

interface ToggleProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'color'> {
  className?: string;
  activeColorOverride?: string;
  label?: string | null;
  dataTestId?: string | null;
}

export default function Toggle({
  className,
  activeColorOverride,
  label = null,
  dataTestId = null,
  ...inputProps
}: ToggleProps) {
  return (
    <label
      className={classnames(
        'DSToggle',
        { 'DSToggle--blue': activeColorOverride === 'blue' },
        className
      )}
    >
      <input {...inputProps} type="checkbox" />
      <span
        data-test-id={dataTestId ?? undefined}
        className="DSToggle__slider"
      />
      {label && <span className="ml2">{label}</span>}
    </label>
  );
}
